import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["type", "input", "menu", "option", "empty", "value", "submit"];

  connect() {
    this.highlightedIndex = -1;
    this.filterOptions();
  }

  changeType() {
    this.valueTarget.value = "";
    this.inputTarget.value = "";
    this.inputTarget.placeholder = `Search ${this.currentType}s…`;
    this.submitTarget.disabled = true;
    this.filterOptions();
    this.open();
    this.inputTarget.focus();
  }

  open() {
    this.filterOptions();
    this.menuTarget.hidden = false;
    this.inputTarget.setAttribute("aria-expanded", "true");
  }

  filter() {
    this.valueTarget.value = "";
    this.submitTarget.disabled = true;
    this.filterOptions();
    this.open();
  }

  select(event) {
    event.preventDefault();
    const option = event.currentTarget;

    this.valueTarget.value = option.dataset.pickerValue;
    this.inputTarget.value = option.dataset.pickerLabel;
    this.submitTarget.disabled = false;
    this.close();
  }

  clickAway(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  onKeydown(event) {
    const options = this.visibleOptions;

    if (event.key === "Escape") {
      this.close();
      return;
    }

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      if (this.menuTarget.hidden) this.open();
      if (options.length === 0) return;

      const step = event.key === "ArrowDown" ? 1 : -1;
      this.highlightedIndex = (this.highlightedIndex + step + options.length) % options.length;
      this.highlight(options[this.highlightedIndex]);
      return;
    }

    if (event.key === "Enter" && !this.menuTarget.hidden && this.highlightedIndex >= 0) {
      event.preventDefault();
      this.select({ preventDefault() {}, currentTarget: options[this.highlightedIndex] });
    }
  }

  validate(event) {
    if (this.valueTarget.value) return;

    event.preventDefault();
    this.open();
    this.inputTarget.focus();
  }

  get currentType() {
    return this.typeTargets.find((input) => input.checked)?.value || "collection";
  }

  get visibleOptions() {
    return this.optionTargets.filter((option) => !option.hidden);
  }

  filterOptions() {
    const query = this.inputTarget.value.trim().toLowerCase();
    let matches = 0;

    this.optionTargets.forEach((option) => {
      const visible = option.dataset.pickerType === this.currentType
        && option.dataset.pickerLabel.toLowerCase().includes(query);
      option.hidden = !visible;
      option.classList.remove("is-highlighted");
      option.setAttribute("aria-selected", "false");
      if (visible) matches += 1;
    });

    this.highlightedIndex = -1;
    this.emptyTarget.hidden = matches > 0;
  }

  highlight(option) {
    this.optionTargets.forEach((item) => {
      const selected = item === option;
      item.classList.toggle("is-highlighted", selected);
      item.setAttribute("aria-selected", selected.toString());
    });
    option.scrollIntoView({ block: "nearest" });
  }

  close() {
    this.menuTarget.hidden = true;
    this.inputTarget.setAttribute("aria-expanded", "false");
    this.highlightedIndex = -1;
    this.optionTargets.forEach((option) => option.classList.remove("is-highlighted"));
  }
}
